{
  "network-error": "Error de red. Verifique su conexión e inténtelo de nuevo.",
  "unknown-error": "Ocurrió un error desconocido.",
  "search": "Buscar",
  "filter": "Filtrar",
  "name": "Nombre",
  "role": "Rol",
  "remove": "Eliminar",
  "street": "Calle",
  "settlement": "Asentamiento",
  "references": "Referencias",
  "opened": "Abierto",
  "closed": "Cerrado",
  "all": "Todos",
  "admin": "Administración",
  "title_agent": "Agente de titulo",
  "buyer": "Comprador",
  "buyers": "Compradores",
  "seller": "Vendedor",
  "sellers": "Vendedores",
  "lenders": "Prestamistas",
  "edit": "Editar",
  "orders": "Ordenes",
  "menu": "Menú",
  "users": "Usuarios",
  "find-order": "Buscar Orden",
  "workspace": "Espacio de trabajo",
  "charges": "Cargos",
  "proceeds": "Productos",
  "closing": "Clausura",
  "password": "Contraseña",
  "state": "Estado",
  "workflow": "Flujo de Trabajo",
  "transaction-types": "Tipos de Transaccion",
  "transaction-type": "Tipo de Transaccion",
  "type": "Tipo",
  "email-templates": "Plantillas de Email",
  "done": "Listo",
  "loading": "cargando...",
  "license-numbers": "Números de licencia",
  "open": "Abierto",
  "welcome-signin": "Bienevenido a Championship Title",
  "save": "Guardar",
  "id": "ID",
  "next": "Siguiente",
  "prev": "Anterior",
  "city": "Ciudad",
  "zip-code": "Codigo Postal",
  "country": "País",
  "continue": "Continuar",
  "organization": "Organización",
  "individual": "Individual",
  "cancel": "Cancelar",
  "county": "Condado",
  "information": "Información",
  "spouse": "esposo/esposa",
  "address": "Domicilio",
  "addresses": "Direcciones",
  "select-one": "Seleccione uno ...",
  "delete": "Borrar",
  "borough": "Municipio",
  "town": "Pueblo",
  "unincorporated-area": "Area no incorporada",
  "residence-1-4": "Residencia (1-4 Familias)",
  "residence-5+": "Residencia (5+ Familias)",
  "commercial": "Comercial",
  "condominium": "Condominio",
  "planned-unit": "Desarrollo de la unidad planificada",
  "land-and-buildings": "Terreno y Edificios",
  "tax": "Impuesto",
  "male": "Masculino",
  "female": "Femenino",
  "connect": "Conectar",
  "pending": "Pendiente",
  "no-defined-yet": "Aún no definido",
  "no-property-address": "Sin dirección aún",
  "searching": "Buscando",
  "invalid": "Invalido",
  "add": "Agregar",
  "to": "Para",
  "modal-delete-confirmation-label": "Confirme escribiendo",
  "modal-delete-cancel": "Cancelar",
  "modal-delete-confirmation": "Si, bórralo",
  "apply": "Aplicar",
  "general": "General",
  "closing-disclosure": "Divulgación de Cierre",
  "label": "Etiqueta",
  "description": "Descripción",
  "property": "Propiedad",
  "party": "Parte",
  "signer": "Firmante",
  "routing": "Routing",
  "bank-name": "Nombre del Banco",
  "bank-address": "Dirección del Banco",
  "account": "Cuenta",
  "reference": "Referencia",
  "transfer": "Transferencia",
  "holdback": "Retención",
  "yes": "Sí",
  "village": "Pueblo",
  "confirm": "Confirmar",
  "no-search-orders": "Sin resultados",
  "split": "Dividir",
  "contacts": "Contactos",
  "close": "Cerrar",
  "gotIt": "Entendido",
  "unexpected-error": "Ocurrió un error inesperado",
  "create": "Crear",
  "status": "Estado",
  "sortBy": "Ordenar por",
  "amount": "Cantidad:",
  "min": "Min",
  "max": "Max",
  "clear-all": "Limpiar todo",
  "clear": "Limpiar",
  "orderBy-amount-low-to-high": "Cantidad de menor a mayor",
  "orderBy-amount-high-to-low": "Cantidad mayor a menor",
  "rows-per-page": "Filas por página:",
  "noChargeSettings": "No se encontraron configuraciones de cargos",
  "copy-text": "Copiar",
  "agency": "Agencia",
  "templates": "Plantillas",
  "byLetterAndNumberLabel": "Por Letra y Número",
  "byCodeLabel": "Por Código",
  "letterLabel": "Letra",
  "numberLabel": "Número",
  "codeLabel": "Código",
  "setting": "Configuración",
  "payeeLabel": "Beneficiario",
  "payeesLabel": "Beneficiarios",
  "payersLabel": "Pagadores",
  "addPayeeLabel": "Agregar Beneficiario",
  "addPayerLabel": "Agregar Pagador",
  "removeLabel": "Eliminar",
  "roleLabel": "Rol",
  "buyerBeforeLabel": "Comprador Antes",
  "buyerAtLabel": "Comprador En",
  "sellerBeforeLabel": "Vendedor Antes",
  "sellerAtLabel": "Vendedor En",
  "byOthersLabel": "Por Otros",
  "presetAmountLabel": "Monto Preestablecido",
  "percentageLabel": "Porcentaje",
  "beforeClosingLabel": "Antes del Cierre",
  "atClosingLabel": "En el Cierre",
  "otherLabel": "Otro",
  "orderMapExplorerTitle": "Mapa de Órdenes",
  "propertyFilterTitle": "Filtro de Propiedad",
  "stateAndEquivalentLabel": "Estado y Equivalente",
  "countyLabel": "Condado",
  "coreAreaLabel": "Área central",
  "metropolitanDivisionLabel": "División Metropolitana",
  "urbanAreaLabel": "Área Urbana",
  "searchByZipPlaceholder": "Buscar por código postal",
  "relatedOrdersTitle": "Órdenes Relacionadas",
  "totalLabel": "Total",
  "filterByAddressPlaceholder": "Filtrar por dirección o número de orden",
  "or": "O",
  "actionsHeader": "Acciones",
  "phonesLabel": "Teléfonos",
  "addressesLabel": "Direcciones",
  "emailsLabel": "Correos",
  "createContactButton": "Crear Contacto",
  "createPersonButton": "Crear Persona",
  "createOrganizationButton": "Crear Organización",
  "updateChargeSettingTitle": "Actualizar Configuración de Cargo",
  "createChargeSettingTitle": "Crear Configuración de Cargo",
  "percent": "Porcentaje",
  "no": "No",
  "error-try-again": "Hubo un error, por favor intente de nuevo",
  "terms-of-service": "Términos de Servicio",
  "selected-contact": "Contacto Seleccionado:",
  "ok": "Ok",
  "payee-select-contact": "Por favor seleccione un contacto, o puede crear uno nuevo en la última opción:",
  "payee-found-text": "Encontramos el siguiente texto como beneficiario en el documento:",
  "payee-current-contact": "Contacto actual seleccionado como beneficiario:",
  "months-per-year": "Meses por año",
  "paid-in-advance": "Pagado por Adelantado",
  "select-county-tdi": "Seleccionar Condado (Código TDI)",
  "number-of-pages": "Número de Páginas",
  "number-of-names": "Número de Nombres",
  "delete-setting": "Eliminar Configuración",
  "delete-setting-confirm": "¿Está seguro de que desea eliminar la configuración?",
  "view-order": "Ver orden",
  "edit-parties": "Editar partes",
  "assistant-placeholder": "Asistente",
  "retry": "Reintentar",
  "view": "Ver >",
  "configuration": "Configuración",
  "inference": "Inferencia",
   "english": "Inglés",
   "spanish": "Español",
   "language": "Idioma",
  "change-to-spanish": "Cambiar a Español",
  "change-to-english": "Change to English",
  "target-spanish": "Español",
  "target-english": "English",
   "ai": "IA",
  "notDefinedYet": "aún no definido",
  "agent-name": "Nombre del Agente",
  "on-progress": "En Progreso",
  "receiptInfo": "{{description}}({{amount}}, fecha: {{date}})",
  "kindsLabel": "tipos: {{kinds}}",
  "source": "Fuente",
  "createWireTransfer": "Crear Transferencia Bancaria",
  "and": "y",
  "from": "de",
  "filePath": "Ruta del Archivo",
  "fileName": "Nombre del Archivo",
  "fileType": "Tipo de Archivo",
  "fileSize": "Tamaño del Archivo",
  "creationDate": "Fecha de Creación",
  "lastModifiedDate": "Fecha de Última Modificación",
  "lastAccessedDate": "Fecha de Último Acceso",
  "size": "Tamaño",
  "date": "Fecha",
  "not-set": "No establecido",
  "internal-server-error": "Error interno del servidor",
  "drop-items-here": "Suelta los elementos aquí",
  "aiConfig": {
    "title": "Opciones de IA",
    "newPrompt": "Nuevo Prompt",
    "configureAI": "Configurar Opciones de IA",
    "cancel": "Cancelar",
  "save": "Guardar",
  "back": "Regresar",
    "update": "Actualizar",
    "create": "Crear",
    "delete": "Eliminar",
    "confirmDelete": "¿Está seguro de que desea eliminar este prompt?",
    "promptName": "Nombre del Prompt",
    "promptModel": "Modelo",
    "actions": "Acciones",
    "noPrompts": "No hay prompts configurados",
    "editPrompt": "Editar Prompt",
    "createPrompt": "Crear Prompt",
    "promptNameLabel": "Nombre del Prompt",
    "promptModelLabel": "Modelo",
    "descriptionLabel": "Descripción",
    "contentLabel": "Contenido",
    "promptSystem": "Prompt del Sistema",
    "promptSystemEnglish": "Inglés",
    "promptSystemSpanish": "Español",
    "promptScreen": "Prompt de la Pantalla",
    "promptScreenEnglish": "Inglés",
    "promptScreenSpanish": "Español",
    "promptImage": "Prompt de Imagen",
    "promptImageEnglish": "Inglés",
    "promptImageSpanish": "Español",
    "modelAgent": "Modelo de Agente IA"
  }
}
